import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type {
  CampaignRankingResponse,
  CampaignRankingScope
} from '../types/campaign'

import { api } from '@/shared/services/api'

export function useCampaignRanking(
  campaignId: number,
  scope: CampaignRankingScope = 'global',
  options?: { page?: number; enabled?: boolean }
) {
  const page = options?.page ?? 1

  const query = useQuery({
    queryKey: ['/user/campaigns', campaignId, 'ranking', scope, page],
    enabled: Number.isFinite(campaignId) && (options?.enabled ?? true),
    // Mantém a página anterior visível enquanto a nova carrega — evita
    // voltar ao skeleton a cada troca de página.
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const { data } = await api.get<{ record: CampaignRankingResponse }>(
        `/user/campaigns/${campaignId}/ranking`,
        { params: { scope, page } }
      )
      return data.record
    }
  })

  return {
    ...query,
    records: query.data?.records ?? [],
    currentUser: query.data?.current_user,
    campaignLink: query.data?.campaign_link,
    pagination: query.data?.pagination
  }
}
